import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosDefaultApi } from "src/lib/axios";
import { MutationConfig, queryClient } from "src/lib/react-query";
import useNotification from "src/store/Notifications/useNotification";


const deletePendingStatus = ({ pendingStatusId }: { pendingStatusId: number }): Promise<string> => {
  return axiosDefaultApi.delete(`/api/PendingStatus/DeletePendingStatus/${pendingStatusId}`);
};

type QueryFnType = typeof deletePendingStatus;

type UseDeletePendingStatusOptions = {
  pendingStatusId: number;
  config?: MutationConfig<QueryFnType>;
};

export const useDeletePendingStatus = ({ config }: UseDeletePendingStatusOptions) => {
  const { addNotification, setIsNotificationVisible } = useNotification();
  return useMutation({
    onError: (error: AxiosError<any>) => {
      if (error.response && error.response.data && error.response.data.message) {
        const responseMessage = error.response?.data.message;
        console.log(responseMessage);
        addNotification(responseMessage.toString(), 500);
        setIsNotificationVisible(true);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["getAllPendingStatus"]);
      addNotification(`Η Κατηγορία Εκκρεμότητας Διαγράφηκε.`, 200);
      setIsNotificationVisible(true);
    },
    ...config,
    mutationFn: deletePendingStatus,
  });
};
